import { Link } from 'react-router-dom';
import { categoryLabel } from '../../data/categories';
import { profileHomePath } from '../../lib/routes';
import { PROFILE_LABEL, type Profile } from '../../types/profile';

interface BreadcrumbsProps {
  profile: Profile;
  category?: string;
  title?: string;
}

export function Breadcrumbs({ profile, category, title }: BreadcrumbsProps) {
  return (
    <nav className="breadcrumbs" aria-label="Navegação estrutural">
      <Link to="/">Centro de Ajuda</Link>
      <span aria-hidden="true">›</span>
      <Link to={profileHomePath(profile)}>{PROFILE_LABEL[profile]}</Link>
      {category ? <><span aria-hidden="true">›</span><span>{categoryLabel(category)}</span></> : null}
      {title ? <><span aria-hidden="true">›</span><span aria-current="page">{title}</span></> : null}
    </nav>
  );
}
